<!-- Imports font awesome styles -->
<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css"
      integrity="sha384-B4dIYHKNBt8Bc12p+WXckhzcICo0wtJAoU8YZTY5qE0Id1GSseTk6S+L3BlXeVIU"
      crossorigin="anonymous">

<div style="height: 100%;">
  <app-toggle #deleteToggle>
    <!-- Toolbar -->
    <div class="widget-toolbar-old">
      <app-toggle-button [callbackOnToggle]="callbackOnDeleteToggle">
        <i class="fas fa-trash-alt" style="font-size: 1.5vh"></i>
      </app-toggle-button>

      <input
        style="display: none"
        type="file"
        (change)="onFileChanged($event)"
        accept="image/jpeg"
        #fileInput>
      <button class="widget-toolbar-btn-old" (click)="fileInput.value=''; fileInput.click()">
        <i class="fas fa-cloud-upload-alt" style="font-size: 1.5vh"></i>
      </button>
    </div>

    <!-- Ordered View Content if images are available -->
    <div *ngIf="hasImages" class="ordered-view">
      <!-- Button Left -->
      <div style="width:10%">
        <button class="direction-btn" (click)="handleLeftSwipeBtn()">
          <i class="fas fa-angle-left" style="font-size: 2vh"></i>
        </button>
      </div>

      <!-- Images -->
      <div class="image-container">
        <div class="shown-images" #divcontainer [style.grid-template-columns]="grid_columns_style">
          <app-gallery-image *ngFor="let image of availableImages" style="height: 12vh;"
                              [image]="image"
                              [selectedProject]="selectedProject"
                              (deleteCallback)="onDelete($event[0])">
          </app-gallery-image>
          <div *ngFor="let image of emptyImagePlaceholders" [ngClass]="['empty-img']">
            <img src="" style="height: 100%;">
          </div>
        </div>
        <div class="hidden-images"></div>
      </div>

      <!-- Button Right -->
      <div style="width:10%">
        <button class="direction-btn" (click)="handleRightSwipeBtn()">
          <i class="fas fa-angle-right" style="font-size: 2vh"></i>
        </button>

      </div>
    </div>

    <!-- Ordered View Placeholder Content if no images are available  -->
    <div *ngIf="!hasImages" class="ordered-view">
      <!-- #divcontainer is necessary so in this case the DOM can be built up similar to the case when images are available -->
      <div class="image-container" #divcontainer>
        <i *ngIf="hasImages == false" class="far fa-images" style="font-size: 15vh"></i>
      </div>
    </div>

  </app-toggle>
</div>

